import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FlexLayoutModule } from "@angular/flex-layout";
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import {MatDialogModule, MatIconModule} from '@angular/material';
import { NgxLoadingModule, } from 'ngx-loading';
import { BlogsComponent } from '../blogs/blogs.component';
import { BlogsRouting } from '../blogs/blogs.route';
import { BlogdetailComponent } from './blogdetail/blogdetail.component';
import { BlogmainComponent } from './blogmain/blogmain.component';
import { CategoryComponent } from './category/category.component';
import { SharedModule } from '../common/shared.module';
import { FilterModule } from '../filter/filter.module';


@NgModule({
    imports: [
      CommonModule,
      FlexLayoutModule,
      FormsModule,
      NgbModule,
      NgxLoadingModule,
      RouterModule,
      BlogsRouting,
      SharedModule,
      MatDialogModule,
      MatIconModule,
      FilterModule
    ],
    declarations: [
        BlogsComponent,
        BlogdetailComponent,
        BlogmainComponent,
        CategoryComponent,
    ],
    })
    export class BlogsModule { }
